/**
 * Quote multi-step with form validation code
- needs to be called after the dom has load for script to take effect - using window onload like jquery with document.ready - otherwise will break javascript code on pages
 */
const quoteForm = document.querySelector('.page-template-page-get-a-quote');
/**
 * make sure we don't run this script if the timeline is not present
 */
if (quoteForm !== null) {
	window.onload = function () {
		let currentTab = 0; // Current tab is set to be the first tab (0)
		showTab(currentTab); // Display the current tab

		function fixStepIndicator(n) {
			// This function removes the "active" class of all steps...
			const x = document.getElementsByClassName('step');
			for (let i = 0; i < x.length; i++) {
				x[i].className = x[i].className.replace(' active', '');
			}
			//Text point in side column
			let y = document.getElementsByClassName('steppoint');
			for (i = 0; i < y.length; i++) {
				y[i].className = y[i].className.replace(' active', '');
			}

			//... and adds the "active" class to the current step:

			x[n].className += ' active';
			y[n].className += ' active';
		}

		/**
		 * This function will display the specified tab of the form ..
		 * @param n shows the tab block with the form elements, which there are 4 sections
		 */
		function showTab(n) {
			const x = document.getElementsByClassName('tab');
			if (x[n] !== undefined) {
				x[n].style.display = 'block';
			}
			// ... and fix the Previous/Next buttons:
			if (n === 0) {
				document.getElementById('prevBtn').disabled = true;
			} else {
				document.getElementById('prevBtn').disabled = false;
				document.getElementById('prevBtn').style.display = 'inline';
			}
			if (n === (x.length - 1)) {
				document.getElementById('nextBtn').disabled = true;
			} else {
				document.getElementById('nextBtn').disabled = false;
				document.getElementById('nextBtn').innerHTML = 'Next';
			}
			// ... and run a function that displays the correct step indicator:
			fixStepIndicator(n);
		}

		function nextPrev(n) {
			// This function will figure out which tab to display
			var x = document.getElementsByClassName('tab');

			// Exit the function if any field in the current tab is invalid:
			if (n === 1 && !validateForm()) return false;

			// Hide the current tab:
			x[currentTab].style.display = 'none';

			// Increase or decrease the current tab by 1:
			currentTab = currentTab + n;

			// if you have reached the end of the form... :
			/* if (currentTab >= x.length) {
			//...the form gets submitted:
				document.getElementsByTagName("form").submit();
				return false;
			} */

			// Otherwise, display the correct tab:
			showTab(currentTab);
			return true;
		}

		function validateForm() {
			// This function deals with validation of the form fields
			let x, y, i, valid = true;

			x = document.getElementsByClassName('tab');
			y = x[currentTab].getElementsByTagName('input');

			const inputRequired = 'wpcf7-validates-as-required';
			const emailRequired = 'wpcf7-email';
			const telRequired = 'wpcf7-tel';
			//check for @a-z. in email address
			const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			//Check tel for ()+0-9.
			const telFormat = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([.]?[-]?[\s]?[0-9])+$/;
			/**
			 * Error Message
			 * check if class of msg exist, if not add, so message doesn't repeat more than once
			 * @param elmId - id on the error message
			 * @param topicErr - can edit to make error message to required field
			 * use insert after html at the end of the parent
			 */
			function errorMessage(elmId, topicErr) {
				const errMessage = '<span id="' + elmId + '" class="wpcf7-not-valid-tip" role="alert" aria-hidden="true">*Please enter valid ' + topicErr + ' </span>';

				if (!y[i].classList.contains('msg')) {
					y[i].classList.add('msg');
					y[i].insertAdjacentHTML('afterend', errMessage);
				}
			}

			/**
			 * Remove Error Message
			 * @param elmId prevents undefined or null when html element (error message) is removed from dom!
			 * remove error classes from input for checking if error! - to validate input and w3c aria for screen reader
			 */
			function removeErr(elmId) {
				elmId = document.getElementById(elmId);

				y[i].classList.remove('wpcf7-not-valid');
				y[i].classList.remove('msg');
				y[i].setAttribute('aria-invalid', 'false');

				if (typeof elmId !== 'undefined' && elmId !== null) {
					elmId.remove();
				}
			}

			/**
			 * Adds invalid class to highlight input with red block
			 * adds screen reader aria invalid
			 */
			function addInvalid() {
				y[i].classList.add('wpcf7-not-valid');
				y[i].setAttribute('aria-invalid', 'true');
			}

			// A loop that checks every input field in the current tab:
			for (i = 0; i < y.length; i++) {

				//REQUIRED validate any required input
				if (y[i].classList.contains(inputRequired)) {
					if (y[i].value === '') {
						addInvalid();
						valid = false;
					}
					//Remove red error by taking out the invalid class
					if (y[i].value !== '') {
						y[i].classList.remove('wpcf7-not-valid');
						y[i].setAttribute('aria-invalid', 'false');
					}
				}

				//EMAIL validation looking for @. in input
				if (y[i].classList.contains(emailRequired)) {

					if (!y[i].value.match(mailFormat)) {
						addInvalid();
						//error message function and wording
						errorMessage('EmailErr', 'Email');
						valid = false;
					}
					//if is valid
					if (y[i].value.match(mailFormat)) {
						//remove error message function
						removeErr('EmailErr');
					}
				}

				//PHONE validation looking for no.
				if (y[i].classList.contains(telRequired)) {
					if ((!y[i].value.match(telFormat)) && (y[i].value !== '')) {
						addInvalid();
						//error message function and wording
						errorMessage('msg', 'Phone Number');
						valid = false;
					}
					//if is valid
					if ((y[i].value.match(telFormat)) || (y[i].value === '')) {
						//remove error message function
						removeErr('msg');
					}
				}
			}

			//INDICATOR STEP If the valid status is true, mark the step as finished and valid:
			if (valid) {
				function myFunction(elemClass) {
					let element = document.getElementsByClassName(elemClass)[currentTab];
					element.classList.add('finish');
				}
				myFunction('step');
				myFunction('steppoint');
			}
			return valid; // return the valid status
		}

		this.nextBtn = document.getElementById('nextBtn');
		this.prevBtn = document.getElementById('prevBtn');
		this.nextBtn.addEventListener('click', () => nextPrev(1));
		this.prevBtn.addEventListener('click', () => nextPrev(-1));
	};
};
